import React, { useRef } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateHeight } from '../redux/vansh-reducer';
import './ResizableDiv.css';

const ResizableDiv = ({ children }) => {
  const { height } = useSelector(state => state.vansh);
  const dispatch = useDispatch();

  const divRef = useRef(null);

  // useEffect(() => {
  //   const observer = new ResizeObserver(entries => {
  //     for (const entry of entries) {
  //       const newHeight = entry.contentRect.height;
  //       dispatch(updateHeight(newHeight));
  //     }
  //   });

  //   if (divRef.current) {
  //     observer.observe(divRef.current);
  //   }

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [dispatch]);
  useEffect(() => {
    let timeoutId = null; // Initialize a variable to store the timeout ID

    const observer = new ResizeObserver(entries => {
      for (const entry of entries) {
        const newHeight = entry.contentRect.height;

        // Clear any existing timeout
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        // Set a new timeout to dispatch the action after 500 milliseconds
        timeoutId = setTimeout(() => {
          dispatch(updateHeight(newHeight));
        }, 500);
      }
    });

    if (divRef.current) {
      observer.observe(divRef.current);
    }

    return () => {
      observer.disconnect();

      // Make sure to clear the timeout when the component unmounts
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [dispatch, divRef]);

  return (
    <div
      ref={divRef}
      className="resizable-content"
      style={{ height: height || 200 }}
    >
      {children}
    </div>
  );
};

export default ResizableDiv;
